export default {
  namespaced: true,
  state: {
    filedomain: "https://qdd-yidun.oss-cn-hangzhou.aliyuncs.com/"
  }
}
